import { StandardTextFieldProps } from '@material-ui/core';
import React from 'react';

import { FieldType } from '..';
import { InputValidationResult } from '../..';
import { apiTranslate } from '../../../translations/translations';
import { ValidatedTextInput } from '../../ValidatedTextInput';

interface TextFieldInputProps extends StandardTextFieldProps {
  field: FieldType;
  required: boolean;
  onChangeValidator: (value?: string) => InputValidationResult;
}

const TextField: React.FC<TextFieldInputProps> = (props) => {
  const { field, required, value, onChangeValidator, ...otherProps } = props;

  const handleChange = (value: string): InputValidationResult => {
    let optionalValue: string | undefined = value;

    if (value === undefined || value === '') {
      optionalValue = undefined;
    }

    return onChangeValidator(optionalValue);
  };

  return (
    <ValidatedTextInput
      {...otherProps}
      inputName={field.id}
      required={required}
      value={value !== undefined ? value : ''}
      onChangeValidator={handleChange}
      label={apiTranslate(field.title)}
    />
  );
};

export { TextField };
